import moment from 'moment'

const state = {
  result: {
    easy: {
      last: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      },
      best: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      }
    },
    normal: {
      last: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      },
      best: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      }
    },
    hard: {
      last: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      },
      best: {
        date: '2019-12-31 00:00',
        score: 0,
        time: 0,
        missCount: 0
      }
    }
  }
}

const mutations = {
  SET_LAST_RESULT(state, payload) {
    state.result[payload.level].last = payload
  },
  SET_BEST_RESULT(state, payload) {
    state.result[payload.level].best = payload
  }
}

const actions = {
  setResult({ commit, state }, { level, score, time, missCount }) {
    const bestScore = state.result[level].best.score
    if (score >= bestScore) {
      commit('SET_BEST_RESULT', {
        level,
        date: moment().format('YYYY-MM-DD hh:mm'),
        score,
        time,
        missCount
      })
    }
    commit('SET_LAST_RESULT', {
      level,
      date: moment().format('YYYY-MM-DD hh:mm'),
      score,
      time,
      missCount
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
